import { FovNodes, FovErrorOption, FovErrorType, FovErrorExperience, FovFieldTypes, FovPageType, ComparisonOperators, } from '@contentsquare/fov-constants';
export class ErrorSegmentUtils {
    static getJSErrorFovSegment(errorValue, options) {
        const { pageValue, excludeError } = options || {};
        const errorConditions = ErrorSegmentUtils.isGroupedError(errorValue)
            ? ErrorSegmentUtils.getJSGroupedErrorConditions(errorValue, pageValue, { excludeError })
            : ErrorSegmentUtils.getJSErrorConditions(errorValue, pageValue, { excludeError });
        const conditions = FovNodes.andGroup(...errorConditions);
        return conditions;
    }
    static getAPIErrorFovSegment(errorValue, options) {
        const { pageValue, excludeError } = options || {};
        const errorConditions = ErrorSegmentUtils.isGroupedError(errorValue)
            ? ErrorSegmentUtils.getAPIGroupedErrorConditions(errorValue, pageValue, { excludeError })
            : ErrorSegmentUtils.getAPIErrorConditions(errorValue, pageValue, { excludeError });
        const conditions = FovNodes.andGroup(...errorConditions);
        return conditions;
    }
    static getCustomErrorFovSegment(errorValue, options) {
        const { pageValue, excludeError } = options || {};
        const errorConditions = ErrorSegmentUtils.isGroupedError(errorValue)
            ? ErrorSegmentUtils.getCustomGroupedErrorConditions(errorValue, pageValue, { excludeError })
            : ErrorSegmentUtils.getCustomErrorConditions(errorValue, pageValue, { excludeError });
        const conditions = FovNodes.andGroup(...errorConditions);
        return conditions;
    }
    static getBrowserFov(metadata) {
        const { browserName, browserMajorVersion } = metadata;
        const browserNameFov = FovNodes.filter(FovFieldTypes.Browser, ComparisonOperators.MATCH_EQUALS, browserName);
        const browserVersionFov = FovNodes.filter(FovFieldTypes.BrowserVersion, ComparisonOperators.MATCH_REGEX, `^${browserMajorVersion}`);
        const browserFov = FovNodes.andGroup(browserNameFov, browserVersionFov);
        const browserSegment = FovNodes.andGroup(browserFov);
        return browserSegment;
    }
    static getOSFov(metadata) {
        const { browserOS, browserOSVersion } = metadata;
        const browserOSFov = FovNodes.filter(FovFieldTypes.Os, ComparisonOperators.MATCH_REGEX, browserOS);
        const browserOSVersionFov = FovNodes.filter(FovFieldTypes.WebOsVersion, ComparisonOperators.MATCH_REGEX, browserOSVersion);
        const osFov = FovNodes.andGroup(browserOSFov, browserOSVersionFov);
        const osSegment = FovNodes.andGroup(osFov);
        return osSegment;
    }
    static getCountryFov(metadata) {
        const { countryCode } = metadata;
        const countryFov = FovNodes.orGroup(FovNodes.filter(FovFieldTypes.GeographicArea, ComparisonOperators.MATCH_EQUALS, countryCode));
        const countrySegment = FovNodes.andGroup(countryFov);
        return countrySegment;
    }
    static getJSErrorConditions(errorValue, pageValue, params) {
        const { errorMessage, errorFilename, errorLineNumber, errorColNumber, errorHasMultipleClicks } = errorValue || {};
        const { url, mappingId, pageId, pageName } = pageValue || {};
        const conditions = [];
        const errorFovValue = {
            errorType: FovErrorType.JS,
            experienceOption: (params === null || params === void 0 ? void 0 : params.excludeError) ? FovErrorExperience.HAVE_NOT_EXPERIENCED : FovErrorExperience.EXPERIENCED,
            errorOption: ErrorSegmentUtils.getJSErrorOption(errorValue),
            errorMessage,
            errorColumnNumber: errorColNumber,
            errorLineNumber,
            errorFileName: errorFilename,
            pageOption: ErrorSegmentUtils.getPageOption(pageValue),
            pageUrl: url,
            mappingId,
            pageId,
            pageName,
            errorHasMultipleClicks,
        };
        conditions.push(FovNodes.filter(FovFieldTypes.Error, ComparisonOperators.MATCH_EQUALS, errorFovValue));
        return conditions;
    }
    static getJSGroupedErrorConditions(errorValue, pageValue, params) {
        const { errorGroupId, errorHasMultipleClicks } = errorValue || {};
        const { url, mappingId, pageId, pageName } = pageValue || {};
        const conditions = [];
        const errorFovValue = {
            errorType: FovErrorType.JS,
            experienceOption: (params === null || params === void 0 ? void 0 : params.excludeError) ? FovErrorExperience.HAVE_NOT_EXPERIENCED : FovErrorExperience.EXPERIENCED,
            errorOption: ErrorSegmentUtils.getJSErrorOption(errorValue),
            errorGroupId,
            pageOption: ErrorSegmentUtils.getPageOption(pageValue),
            pageUrl: url,
            mappingId,
            pageId,
            pageName,
            errorHasMultipleClicks,
        };
        conditions.push(FovNodes.filter(FovFieldTypes.Error, ComparisonOperators.MATCH_EQUALS, errorFovValue));
        return conditions;
    }
    static getJSErrorOption(errorValue) {
        let errorOption;
        if (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorGroupId) {
            errorOption = FovErrorOption.GROUPED;
        }
        else if (typeof (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorColNumber) === 'number' &&
            typeof (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorLineNumber) === 'number' &&
            (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorMessage)) {
            errorOption = FovErrorOption.EXACT;
        }
        else if (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorMessage) {
            errorOption = FovErrorOption.NAMED;
        }
        else
            errorOption = FovErrorOption.ANY;
        return errorOption;
    }
    static getAPIErrorConditions(errorValue, pageValue, params) {
        const { errorRequestUrl, errorMethod, errorStatusCode, errorHasMultipleClicks } = errorValue || {};
        const { url, mappingId, pageId, pageName } = pageValue || {};
        const conditions = [];
        const errorFovValue = {
            errorType: FovErrorType.API,
            experienceOption: (params === null || params === void 0 ? void 0 : params.excludeError) ? FovErrorExperience.HAVE_NOT_EXPERIENCED : FovErrorExperience.EXPERIENCED,
            errorOption: ErrorSegmentUtils.getAPIErrorOption(errorValue),
            apiErrorURL: errorRequestUrl,
            apiErrorMethod: errorMethod,
            apiErrorStatusCode: errorStatusCode,
            pageOption: ErrorSegmentUtils.getPageOption(pageValue),
            pageUrl: url,
            mappingId,
            pageId,
            pageName,
            errorHasMultipleClicks,
        };
        conditions.push(FovNodes.filter(FovFieldTypes.Error, ComparisonOperators.MATCH_EQUALS, errorFovValue));
        return conditions;
    }
    static getAPIGroupedErrorConditions(errorValue, pageValue, params) {
        const { errorGroupId, errorHasMultipleClicks } = errorValue || {};
        const { url, mappingId, pageId, pageName } = pageValue || {};
        const conditions = [];
        const errorFovValue = {
            errorType: FovErrorType.API,
            experienceOption: (params === null || params === void 0 ? void 0 : params.excludeError) ? FovErrorExperience.HAVE_NOT_EXPERIENCED : FovErrorExperience.EXPERIENCED,
            errorOption: ErrorSegmentUtils.getAPIErrorOption(errorValue),
            errorGroupId,
            pageOption: ErrorSegmentUtils.getPageOption(pageValue),
            pageUrl: url,
            mappingId,
            pageId,
            pageName,
            errorHasMultipleClicks,
        };
        conditions.push(FovNodes.filter(FovFieldTypes.Error, ComparisonOperators.MATCH_EQUALS, errorFovValue));
        return conditions;
    }
    static getAPIErrorOption(errorValue) {
        let errorOption;
        if (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorGroupId) {
            errorOption = FovErrorOption.GROUPED;
        }
        else if ((errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorMethod) && (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorStatusCode)) {
            errorOption = FovErrorOption.EXACT;
        }
        else if (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorRequestUrl) {
            errorOption = FovErrorOption.NAMED;
        }
        else
            errorOption = FovErrorOption.ANY;
        return errorOption;
    }
    static getCustomErrorConditions(errorValue, pageValue, params) {
        const { errorMessage, customAttributes, errorHasMultipleClicks } = errorValue || {};
        const { url, mappingId, pageId, pageName } = pageValue || {};
        const conditions = [];
        const errorFovValue = {
            errorType: FovErrorType.CUSTOM,
            experienceOption: (params === null || params === void 0 ? void 0 : params.excludeError) ? FovErrorExperience.HAVE_NOT_EXPERIENCED : FovErrorExperience.EXPERIENCED,
            errorOption: ErrorSegmentUtils.getCustomErrorOption(errorValue),
            customErrorMessage: errorMessage,
            customErrorAttributes: customAttributes && Object.entries(customAttributes).join(),
            pageOption: ErrorSegmentUtils.getPageOption(pageValue),
            pageUrl: url,
            mappingId,
            pageId,
            pageName,
            errorHasMultipleClicks,
        };
        conditions.push(FovNodes.filter(FovFieldTypes.Error, ComparisonOperators.MATCH_EQUALS, errorFovValue));
        return conditions;
    }
    static getCustomGroupedErrorConditions(errorValue, pageValue, params) {
        const { errorGroupId, errorHasMultipleClicks } = errorValue || {};
        const { url, mappingId, pageId, pageName } = pageValue || {};
        const conditions = [];
        const errorFovValue = {
            errorType: FovErrorType.CUSTOM,
            experienceOption: (params === null || params === void 0 ? void 0 : params.excludeError) ? FovErrorExperience.HAVE_NOT_EXPERIENCED : FovErrorExperience.EXPERIENCED,
            errorOption: ErrorSegmentUtils.getCustomErrorOption(errorValue),
            errorGroupId,
            pageOption: ErrorSegmentUtils.getPageOption(pageValue),
            pageUrl: url,
            mappingId,
            pageId,
            pageName,
            errorHasMultipleClicks,
        };
        conditions.push(FovNodes.filter(FovFieldTypes.Error, ComparisonOperators.MATCH_EQUALS, errorFovValue));
        return conditions;
    }
    static getCustomErrorOption(errorValue) {
        let errorOption;
        if (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorGroupId) {
            errorOption = FovErrorOption.GROUPED;
        }
        else if ((errorValue === null || errorValue === void 0 ? void 0 : errorValue.customAttributes) && (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorMessage)) {
            errorOption = FovErrorOption.EXACT;
        }
        else if (errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorMessage) {
            errorOption = FovErrorOption.NAMED;
        }
        else
            errorOption = FovErrorOption.ANY;
        return errorOption;
    }
    static getPageOption(pageValue) {
        let pageOption;
        if (pageValue === null || pageValue === void 0 ? void 0 : pageValue.url) {
            pageOption = FovPageType.URL;
        }
        else if (pageValue === null || pageValue === void 0 ? void 0 : pageValue.pageId) {
            pageOption = FovPageType.PAGE;
        }
        else {
            pageOption = FovPageType.ANY;
        }
        return pageOption;
    }
    static isGroupedError(errorValue) {
        return errorValue === null || errorValue === void 0 ? void 0 : errorValue.errorGroupId;
    }
}
//# sourceMappingURL=error-segment.utils.js.map